/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CompanyDto } from '../models/company-dto';
import { CompetitorDto } from '../models/competitor-dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation loadCompany
   */
  static readonly LoadCompanyPath = '/companies/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadCompany$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.LoadCompanyPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadCompany(params: {
    id: string;
  }): Observable<CompanyDto> {

    return this.loadCompany$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * Path part for operation loadCompetitors
   */
  static readonly LoadCompetitorsPath = '/companies/{id}/competitors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadCompetitors()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadCompetitors$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<CompetitorDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.LoadCompetitorsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompetitorDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadCompetitors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadCompetitors(params: {
    id: string;
  }): Observable<CompetitorDto> {

    return this.loadCompetitors$Response(params).pipe(
      map((r: StrictHttpResponse<CompetitorDto>) => r.body as CompetitorDto)
    );
  }

  /**
   * Path part for operation updateCompanyTags
   */
  static readonly UpdateCompanyTagsPath = '/companies/{id}/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyTags$Response(params: {
    id: string;
    body?: Array<string>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.UpdateCompanyTagsPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateCompanyTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyTags(params: {
    id: string;
    body?: Array<string>
  }): Observable<void> {

    return this.updateCompanyTags$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
